<template>
    <div>
        <div class="card">
            <div class="card-header">学生成绩详情管理</div>
            <table class="table table-bordered mb-0">
                <thead>
                <tr>
                    <th class="text-center align-middle" style="width: 10%">序号</th>
                    <th class="text-center align-middle" style="width: 60%">考核项</th>
                    <th class="text-center align-middle" style="width: 10%">满分</th>
                    <th class="text-center align-middle" style="width: 20%">成绩</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(ass, index) in projectAssessmentData">
                    <td class="text-center align-middle">{{index+1}}</td>
                    <td class="text-left align-middle">{{ass.assessment}}</td>
                    <td class="text-center align-middle">{{ass.score}}</td>
                    <td class="text-center align-middle">{{getStudentScore(index)}}</td>
                </tr>
                </tbody>
            </table>
        </div>

    </div>
</template>

<script>
import studyApi from "@/utils/api/study";
import projectApi from "@/utils/api/project";
export default {
    name: "StudentScoreEdit",
    props: {
        studentClassId: {type: String, required: true},
    },
    data: function () {
        return {
            projectId: '',
            projectAssessmentData: [],
            studentClassInfo: {},
        };
    },
    mounted() {
        this.getStudentClassInfo();
    },
    methods: {
        getStudentClassInfo() {
            studyApi.studentClass.getStudentClassInfo(this.studentClassId).then(res => {
                let data = res.data;
                data.scoreDetailObject = data.scoreDetail? JSON.parse(data.scoreDetail): [];
                this.studentClassInfo = data;

                this.projectId = this.studentClassInfo.projectId;
                this.getProjectAssessmentData();
            });
        },
        getProjectAssessmentData() {
            projectApi.project.assessment.getProjectAssessmentData(this.projectId).then(res => {
                this.projectAssessmentData = res.data;
            });
        },

        getStudentScore(index) {
            let result = '';
            if (this.studentClassInfo.scoreDetailObject && this.studentClassInfo.scoreDetailObject.length!==0) {
                console.log(this.studentClassInfo.scoreDetailObject[index]);
                result = this.studentClassInfo.scoreDetailObject[index].assessmentScore;
            }
            return result;
        }
    }
}
</script>

<style scoped>

</style>